import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useEffectOnce } from 'usehooks-ts';
import { Col, Row } from 'react-bootstrap';
import { map, isUndefined } from 'lodash';

import { NoData, Loading } from '@components/Base';
import { isEmptyArray } from '@utils/lodash';

import { insurancePolicyItemsFetch } from './action';
import { selectDashboardPageReducer } from './selector';
import { PolicyItemView } from './policy-item-view';

const DashboardPage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { policyItems } = useSelector(selectDashboardPageReducer);

  useEffectOnce(() => {
    dispatch(insurancePolicyItemsFetch());
  });

  if (isUndefined(policyItems)) return <Loading />;
  if (isEmptyArray(policyItems)) return <NoData />;

  return (
    <section>
      <h5 className="mb-4">{t('common:dashboard')}</h5>
      <Row className="mb-4 gy-5" data-testid="dashboard-insurance-card-list">
        {map(policyItems, (policyItem) => (
          <Col xl={9} key={policyItem.id}>
            <PolicyItemView policyItem={policyItem} />
          </Col>
        ))}
      </Row>
    </section>
  );
};

export { DashboardPage };
